import { render, staticRenderFns } from "./StudyProgramForm.vue?vue&type=template&id=64e64d34&scoped=true"
import script from "./StudyProgramForm.vue?vue&type=script&lang=ts"
export * from "./StudyProgramForm.vue?vue&type=script&lang=ts"
import style0 from "./StudyProgramForm.vue?vue&type=style&index=0&id=64e64d34&prod&lang=scss&scoped=true"
import style1 from "./StudyProgramForm.vue?vue&type=style&index=1&id=64e64d34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e64d34",
  null
  
)

export default component.exports